<template>
  <b-modal
    title="Adicionar pessoa na estrutura"
    ok-title="Adicionar"
    cancel-title="Cancelar"
    ref="modal-add"
    @ok="submit"
  >
    <h5 v-if="structure_item" class="border-bottom mb-2 pb-2">
      {{ structure_item.name }}
    </h5>
    <b-form-group label="Pessoa Física:">
      <Responsible
        v-model="item.physical_person_id"
        placeholder="Pessoa Física "
        :state="validateState('physical_person_id')"
      />
      <b-form-invalid-feedback
        >Pessoa física é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>
    <b-form-group label="Cargo:">
      <b-form-input
        v-model="item.role"
        :state="validateState('role')"
        placeholder="Cargo"
      />
      <b-form-invalid-feedback
        >Cargo é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>
  </b-modal>
</template>

<script>
import Responsible from "@/modules/physical_people/components/Responsible.vue";
import { required, minLength } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { mapActions } from "vuex";

export default {
  components: { Responsible },
  props: {
    structure_item: {
      type: Object,
    },
  },
  mixins: [validationMixin],
  data: () => ({
    item: {
      physical_person_id: null,
      role: null,
    },
  }),
  validations: {
    item: {
      physical_person_id: {
        required,
      },
      role: {
        required,
        minLength: minLength(2),
      },
    },
  },
  methods: {
    ...mapActions("organizational_structures", ["ActionAddPhysicalPeople"]),
    async submit(evt) {
      evt.preventDefault();

      this.$v.item.$touch();
      if (!this.$v.item.$anyError) {
        let payload = {
          id: this.structure_item.id,
          physical_people: [this.item],
        };

        await this.ActionAddPhysicalPeople(payload);
        this.$refs["modal-add"].hide();
      }
    },
    show() {
      this.$refs["modal-add"].show();
      this.item = {
        physical_person_id: null,
        role: null,
      };
      this.$v.item.$reset();
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.item[name];
      return $dirty ? !$error : null;
    },
  },
};
</script>

<style>
</style>
